import {Box, Checkbox, FormControlLabel, Typography} from "@mui/material";
import TextAreaLine from "../ui/textAreaLine";
import InputLine from "../ui/inputLine";
import SelectLine from "../ui/selectLine";
import {useTranslation} from "react-i18next";
import {PAGE_APPLICATIONS} from "../../../locales/pages/namespaces";

const MAX_CHARS = 3000;

const Step4Form = ({ formik, currencies, language,error }) => {
    const {
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        setFieldValue,
    } = formik;
    const {t} = useTranslation(PAGE_APPLICATIONS)
    const renderError = (name) =>
        touched[name] &&
        errors[name] && (
            <Typography sx={{ color: "red", fontSize: 13, mt: -1, mb: 2 }}>
                {errors[name]}
            </Typography>
        );

    return (
        <Box sx={{ mt: 6, maxWidth: 1280 }}>
            <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#004B88", mb: 1 }}>
                {t("Organization information")}
            </Typography>

            <Typography sx={{ fontSize: 14, color: "#004B88", mb: 2, maxWidth: 900 }}>
                {t("OrgInfoText")}
            </Typography>

            <TextAreaLine
                label={t("History")}
                name="historyMission"
                required
                value={values.historyMission}
                onChange={(e) => {
                    if (e.target.value.length <= MAX_CHARS)
                        setFieldValue("historyMission", e.target.value);
                }}
                onBlur={handleBlur}
                error={touched.historyMission && errors.historyMission}
                helperText={errors.historyMission}
            />
            <Typography sx={{ fontSize: 12, color: "#666", mt: 0.5 }}>
                {values.historyMission.length}/{MAX_CHARS}
            </Typography>

            {/* ---------------- REQUEST DESCRIPTION ---------------- */}
            <Typography sx={{ fontWeight: 700, fontSize: 16, color: "#004B88", mt: 5, mb: 1 }}>
                {t("Request description")}
            </Typography>

            <Typography sx={{ fontSize: 14, color: "#004B88", mb: 2, maxWidth: 900 }}>
                {t("RequestDescriptionText")}
            </Typography>

            <TextAreaLine
                label={t("Purpose of request")}
                name="requestDescription"
                required
                value={values.requestDescription}
                onChange={(e) => {
                    if (e.target.value.length <= MAX_CHARS)
                        setFieldValue("requestDescription", e.target.value);
                }}
                onBlur={handleBlur}
                error={touched.requestDescription && errors.requestDescription}
                helperText={errors.requestDescription}
            />
            <Typography sx={{ fontSize: 12, color: "#666", mt: 0.5 }}>
                {values.requestDescription.length}/{MAX_CHARS}
            </Typography>

            <Box
                sx={{
                    mt: 4,
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 4,
                    maxWidth: 600,
                }}
            >
                <Box sx={{maxWidth:"77%"}}>
                <InputLine
                    label={t("AmountLabel")}
                    name="amount"
                    required
                    value={values.amount}
                    onChange={(e) => {
                        // allow only integers
                        const val = e.target.value.replace(/\D/g, "");
                        setFieldValue("amount", val);
                    }}
                    onBlur={handleBlur}
                    error={touched.amount && errors.amount}
                    helperText={errors.amount}
                />

                <SelectLine
                    label={t("Currency")}
                    name="currency"
                    required
                    value={values.currency}
                    onChange={handleChange}
                    onBlur={handleBlur}
                      options={currencies.map(c => ({
                    value: c.Id,
                    label: language === "el" ? c.NameEL : c.NameEN
                }))}
                    error={touched.currency && errors.currency}
                    helperText={errors.currency}
                />
                </Box>
                {/*<FormControlLabel*/}
                {/*    control={*/}
                {/*        <Checkbox*/}
                {/*            checked={formik.values.campaignAgreement}*/}
                {/*            onChange={(e) =>*/}
                {/*                formik.setFieldValue("campaignAgreement", e.target.checked)*/}
                {/*            }*/}
                {/*            sx={{*/}
                {/*                color: "#004B88",*/}
                {/*                "&.Mui-checked": { color: "#004B88" },*/}
                {/*            }}*/}
                {/*        />*/}
                {/*    }*/}
                {/*    label={t("CampaignAgreement")}*/}
                {/*    sx={{ color: "#004B88", mt: 2 }}*/}
                {/*/>*/}

                {formik.touched.campaignAgreement && formik.errors.campaignAgreement && (
                    <Typography sx={{ color:"#C70000", fontSize: 14 }}>
                        {formik.errors.campaignAgreement}
                    </Typography>
                )}

            </Box>

            <Typography sx={{ fontSize: 12, color: "#004B88", mt: 4, maxWidth: 900 }}>
                {t("FinalNote")}
            </Typography>
        </Box>
    );
};

export default Step4Form;
